unit UVmPosForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Buttons,
  UMatModel, UVmPosModel, WEBLib.SpeechRecognition;

type
  TInputMode = (imScanner, imMic, imKeyboard, imUnknown);

  TVmPosForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlMain: TPanel;
    pnlButtons: TPanel;
    lblArtNr: TLabel;
    lblArtNr1: TLabel;
    lblBez: TLabel;
    lblBez1: TLabel;
    lblMenge: TLabel;
    edtMenge: TEdit;
    lblMeEinh: TLabel;
    btnStorePos: TBitBtn;
    procedure btnBackClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btnStorePosClick(Sender: TObject);
    procedure edtMengeKeyPress(Sender: TObject; var Key: Char);
    procedure SpeechRecNoResultMatch(Sender: TObject; Phrases: TStrings);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FVmPos: TVmPosModel;
    FMode: TInputMode;
    function CheckMask: Boolean;
    function GetMask: Boolean;
    procedure SetMask;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetVmPos(const Value: TVmPosModel);
    procedure SetMode(const Value: TInputMode);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property VmPos: TVmPosModel read FVmPos write SetVmPos;
    property Mode: TInputMode read FMode write SetMode;
  protected procedure LoadDFMValues; override; end;

var
  VmPosForm: TVmPosForm;

implementation

uses
  UEssentialHelper;

{$R *.dfm}
{ TForm1 }

procedure TVmPosForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.VmPos := nil;
  Self.Close;
end;

procedure TVmPosForm.btnStorePosClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if Self.CheckMask and Self.GetMask then
    Self.Close;
end;

function TVmPosForm.CheckMask: Boolean;
var
  error: string;
  d: Double;
begin
  error := '';
  if (error = '') and (Trim(edtMenge.Text) = '') then
  begin
    error := 'Menge darf nicht leer sein!';
    edtMenge.SetFocus;
  end;
  if (error = '') and not UEssentialHelper.TryStrToFloat(Trim(edtMenge.Text), d)
  then
  begin
    error := 'Menge ist keine gültige Fließkommazahl!';
    edtMenge.SetFocus;
  end;
  if (error = '') and (d <= 0) then
  begin
    error := 'Die Menge muss größer Null sein!';
    edtMenge.SetFocus;
  end;
  if error <> '' then
    MessageDLG(error, mtWarning, [mbOK], nil);
  Result := error = '';
end;

procedure TVmPosForm.edtMengeKeyPress(Sender: TObject; var Key: Char);
begin
  if not(Key in ['0' .. '9', ',', #8]) then
    Key := #0;
end;

function TVmPosForm.GetMask: Boolean;
var
  d: Double;
begin
  Result := UEssentialHelper.TryStrToFloat(edtMenge.Text, d);
  Self.VmPos.Menge := d;
end;

procedure TVmPosForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
end;

procedure TVmPosForm.SetMask;
begin
  lblArtNr1.Caption := '';
  lblBez1.Caption := '';
  lblMeEinh.Caption := '';
  edtMenge.Text := '';
  if Self.VmPos <> nil then
  begin
    if Self.VmPos.Mat <> nil then
    begin
      lblArtNr1.Caption := Self.VmPos.Mat.ArtNr;
      lblBez1.Caption := Self.VmPos.Mat.Bezeichnung;
      lblMeEinh.Caption := Self.VmPos.Mat.MeEinheit;
    end;
    edtMenge.Text := FloatToStr(Self.VmPos.Menge);
    edtmenge.SetFocus;
  end
end;

procedure TVmPosForm.SetMode(const Value: TInputMode);
begin
  FMode := Value;
end;

procedure TVmPosForm.SetVmPos(const Value: TVmPosModel);
begin
  FVmPos := Value;
  Self.SetMask;
end;

procedure TVmPosForm.SpeechRecNoResultMatch(Sender: TObject; Phrases: TStrings);
begin
  edtMenge.Text := Phrases[0];
end;

procedure TVmPosForm.WebFormCreate(Sender: TObject);
begin
  Self.VmPos := nil;
  Self.Mode := imUnknown;
end;

procedure TVmPosForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TVmPosForm.WebFormResize(Sender: TObject);
var
  i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Artikeleingabe';
    i := (Self.ClientHeight - pnlHeader.Height - pnlButtons.Height -
      pnlMain.Height) div 2;
    if i < 0 then
      i := 0;
    pnlMain.Top := pnlHeader.Height + i;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Artikeleingabe';
    i := (Self.ClientHeight - pnlHeader.Height - pnlButtons.Height -
      pnlMain.Height - pnlFooter.Height) div 2;
    if i < 0 then
      i := 0;
    pnlMain.Top := pnlHeader.Height + i;

  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  btnStorePos.Left := pnlButtons.ClientWidth - btnStorePos.Width - 4;
  i := (Self.ClientWidth - pnlMain.Width) div 2;
  if i < 0 then
    i := 0;
  pnlMain.Left := i;
end;

procedure TVmPosForm.WebFormShow(Sender: TObject);
begin
  if Self.Mode = imKeyboard then
    edtMenge.SetFocus;
  if Self.Mode = imScanner then
    btnStorePos.SetFocus;
end;

procedure TVmPosForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlMain := TPanel.Create(Self);
  lblArtNr := TLabel.Create(Self);
  lblArtNr1 := TLabel.Create(Self);
  lblBez := TLabel.Create(Self);
  lblBez1 := TLabel.Create(Self);
  lblMenge := TLabel.Create(Self);
  lblMeEinh := TLabel.Create(Self);
  edtMenge := TEdit.Create(Self);
  pnlButtons := TPanel.Create(Self);
  btnStorePos := TBitBtn.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlMain.BeforeLoadDFMValues;
  lblArtNr.BeforeLoadDFMValues;
  lblArtNr1.BeforeLoadDFMValues;
  lblBez.BeforeLoadDFMValues;
  lblBez1.BeforeLoadDFMValues;
  lblMenge.BeforeLoadDFMValues;
  lblMeEinh.BeforeLoadDFMValues;
  edtMenge.BeforeLoadDFMValues;
  pnlButtons.BeforeLoadDFMValues;
  btnStorePos.BeforeLoadDFMValues;
  try
    Name := 'VmPosForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UVmPosForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Artikeleingabe';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UVmPosForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlMain.SetParentComponent(Self);
    pnlMain.Name := 'pnlMain';
    pnlMain.Left := 160;
    pnlMain.Top := 160;
    pnlMain.Width := 297;
    pnlMain.Height := 141;
    pnlMain.Caption := 'pnlMain';
    pnlMain.ChildOrder := 2;
    pnlMain.ShowCaption := False;
    lblArtNr.SetParentComponent(pnlMain);
    lblArtNr.Name := 'lblArtNr';
    lblArtNr.Left := 8;
    lblArtNr.Top := 8;
    lblArtNr.Width := 55;
    lblArtNr.Height := 15;
    lblArtNr.Caption := 'Artikel-Nr.';
    lblArtNr.HeightPercent := 100.000000000000000000;
    lblArtNr.WidthPercent := 100.000000000000000000;
    lblArtNr1.SetParentComponent(pnlMain);
    lblArtNr1.Name := 'lblArtNr1';
    lblArtNr1.Left := 8;
    lblArtNr1.Top := 27;
    lblArtNr1.Width := 52;
    lblArtNr1.Height := 15;
    lblArtNr1.Caption := 'lblArtNr1';
    lblArtNr1.Font.Charset := DEFAULT_CHARSET;
    lblArtNr1.Font.Color := clWindowText;
    lblArtNr1.Font.Height := -12;
    lblArtNr1.Font.Name := 'Segoe UI';
    lblArtNr1.Font.Style := [fsBold];
    lblArtNr1.HeightPercent := 100.000000000000000000;
    lblArtNr1.ParentFont := False;
    lblArtNr1.WidthPercent := 100.000000000000000000;
    lblBez.SetParentComponent(pnlMain);
    lblBez.Name := 'lblBez';
    lblBez.Left := 8;
    lblBez.Top := 50;
    lblBez.Width := 107;
    lblBez.Height := 15;
    lblBez.Caption := 'Artikel-Bezeichnung';
    lblBez.HeightPercent := 100.000000000000000000;
    lblBez.WidthPercent := 100.000000000000000000;
    lblBez1.SetParentComponent(pnlMain);
    lblBez1.Name := 'lblBez1';
    lblBez1.Left := 8;
    lblBez1.Top := 69;
    lblBez1.Width := 41;
    lblBez1.Height := 15;
    lblBez1.Caption := 'lblBez1';
    lblBez1.Font.Charset := DEFAULT_CHARSET;
    lblBez1.Font.Color := clWindowText;
    lblBez1.Font.Height := -12;
    lblBez1.Font.Name := 'Segoe UI';
    lblBez1.Font.Style := [fsBold];
    lblBez1.HeightPercent := 100.000000000000000000;
    lblBez1.ParentFont := False;
    lblBez1.WidthPercent := 100.000000000000000000;
    lblMenge.SetParentComponent(pnlMain);
    lblMenge.Name := 'lblMenge';
    lblMenge.Left := 8;
    lblMenge.Top := 92;
    lblMenge.Width := 37;
    lblMenge.Height := 15;
    lblMenge.Caption := 'Menge';
    lblMenge.HeightPercent := 100.000000000000000000;
    lblMenge.WidthPercent := 100.000000000000000000;
    lblMeEinh.SetParentComponent(pnlMain);
    lblMeEinh.Name := 'lblMeEinh';
    lblMeEinh.Left := 94;
    lblMeEinh.Top := 114;
    lblMeEinh.Width := 36;
    lblMeEinh.Height := 15;
    lblMeEinh.Caption := 'Einheit';
    lblMeEinh.HeightPercent := 100.000000000000000000;
    lblMeEinh.WidthPercent := 100.000000000000000000;
    edtMenge.SetParentComponent(pnlMain);
    edtMenge.Name := 'edtMenge';
    edtMenge.Left := 8;
    edtMenge.Top := 111;
    edtMenge.Width := 80;
    edtMenge.Height := 22;
    edtMenge.Alignment := taRightJustify;
    edtMenge.ChildOrder := 5;
    edtMenge.HeightPercent := 100.000000000000000000;
    edtMenge.Text := 'edtMenge';
    edtMenge.WidthPercent := 100.000000000000000000;
    SetEvent(edtMenge, Self, 'OnKeyPress', 'edtMengeKeyPress');
    pnlButtons.SetParentComponent(Self);
    pnlButtons.Name := 'pnlButtons';
    pnlButtons.Left := 0;
    pnlButtons.Top := 392;
    pnlButtons.Width := 640;
    pnlButtons.Height := 64;
    pnlButtons.Align := alBottom;
    pnlButtons.Caption := 'pnlButtons';
    pnlButtons.ChildOrder := 3;
    pnlButtons.ShowCaption := False;
    SetEvent(pnlButtons, Self, 'OnClick', 'btnStorePosClick');
    btnStorePos.SetParentComponent(pnlButtons);
    btnStorePos.Name := 'btnStorePos';
    btnStorePos.Left := 580;
    btnStorePos.Top := 8;
    btnStorePos.Width := 48;
    btnStorePos.Height := 48;
    btnStorePos.Hint := 'Speichern';
    btnStorePos.Color := clNone;
    btnStorePos.Glyph.LoadFromFile('UVmPosForm.pnlButtons.btnStorePos.Glyph.png');
    btnStorePos.GlyphSize := 32;
    btnStorePos.HeightPercent := 100.000000000000000000;
    btnStorePos.ShowHint := True;
    btnStorePos.WidthPercent := 100.000000000000000000;
    SetEvent(btnStorePos, Self, 'OnClick', 'btnStorePosClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlMain.AfterLoadDFMValues;
    lblArtNr.AfterLoadDFMValues;
    lblArtNr1.AfterLoadDFMValues;
    lblBez.AfterLoadDFMValues;
    lblBez1.AfterLoadDFMValues;
    lblMenge.AfterLoadDFMValues;
    lblMeEinh.AfterLoadDFMValues;
    edtMenge.AfterLoadDFMValues;
    pnlButtons.AfterLoadDFMValues;
    btnStorePos.AfterLoadDFMValues;
  end;
end;

end.
